// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: calc(16px + var(--density-spacing, 0.5rem));
  z-index: 1000000;
  display: flex;
  gap: 20px;
  padding: calc(var(--density-padding, 0.5rem) / 4) 0;
  flex-shrink: 0;
  align-items: center;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  font-size: 13.33333px;
}
:host.code {
  margin-bottom: unset;
}

.buttons {
  display: flex;
  align-items: center;
}
.buttons button, .buttons ::ng-deep button {
  width: 18px;
  height: 18px;
  padding: 0;
  font-size: 9px;
  opacity: 0.7;
  z-index: 2000;
  margin: unset !important;
  border: none;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.buttons button:hover, .buttons ::ng-deep button:hover {
  opacity: 1;
}
.buttons.custom-buttons ::ng-deep .mat-mdc-icon-button {
  width: 18px;
  height: 18px;
  padding: 0;
  line-height: 18px;
}
.buttons.custom-buttons ::ng-deep .mat-mdc-icon-button .mat-mdc-button-touch-target {
  width: 18px;
  height: 18px;
}

.dock-container {
  position: relative;
  display: flex;
  align-items: center;
}

.dock-menu {
  position: absolute;
  top: 100%;
  right: 0;
  display: flex;
  gap: 2px;
  padding: 4px;
  background: var(--preset-card, #073642);
  border: 1px solid rgba(128, 128, 128, 0.5);
  border-radius: 4px;
  z-index: 3000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
.dock-menu button {
  width: 24px;
  height: 24px;
  padding: 2px;
  border: 1px solid transparent;
  border-radius: 3px;
  background: transparent;
  cursor: pointer;
  opacity: 0.8;
}
.dock-menu button:hover {
  opacity: 1;
  background: rgba(128, 128, 128, 0.2);
  border-color: rgba(128, 128, 128, 0.4);
}

button mat-icon, .buttons ::ng-deep mat-icon {
  font-size: 14px;
  line-height: 14px;
  height: 14px;
  width: 14px;
  color: currentColor;
}

.buttons.custom-buttons button {
  color: var(--preset-foreground, #93a1a1);
}
.buttons.custom-buttons button mat-icon {
  color: var(--preset-foreground, #93a1a1);
}

.title {
  font-weight: bold;
  margin-left: 5px;
  margin-top: 5px;
}
.title .dirty-indicator {
  color: var(--preset-primary, #2aa198);
  margin-left: 2px;
}

.subtitle {
  font-size: 11px;
  opacity: 0.5;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/widget-titlebar/widget-titlebar.component.scss"],"names":[],"mappings":"AAAA;EAEE,mDAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,mDAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,qBAAA;AADF;AAGE;EACE,oBAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFJ;AAII;EACE,UAAA;AAFN;AAQI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AANN;AAQM;EACE,WAAA;EACA,YAAA;AANR;;AAYA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AATF;;AAYA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,uCAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AATF;AAWE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AATJ;AAWI;EACE,UAAA;EACA,oCAAA;EACA,sCAAA;AATN;;AAcA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAXF;;AAgBE;EACE,wCAAA;AAbJ;AAeI;EACE,wCAAA;AAbN;;AAkBA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAfF;AAiBE;EACE,qCAAA;EACA,gBAAA;AAfJ;;AAmBA;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAhBF","sourcesContent":[":host {\n  // Height varies with density: compact=16px, default=20px, comfortable=28px\n  height: calc(16px + var(--density-spacing, 0.5rem));\n  z-index: 1000000;\n  display: flex;\n  gap: 20px;\n  padding: calc(var(--density-padding, 0.5rem) / 4) 0;\n  flex-shrink: 0;\n  align-items: center;\n  cursor: default;\n  user-select: none;\n\n  font-size: 13.33333px;\n\n  &.code {\n    margin-bottom: unset;\n  }\n}\n\n.buttons {\n  display: flex;\n  align-items: center;\n\n  & button, & ::ng-deep button {\n    width: 18px;\n    height: 18px;\n    padding: 0;\n    font-size: 9px;\n    opacity: 0.7;\n    z-index: 2000;\n    margin: unset !important;\n    border: none;\n    background: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  // Style mat-icon-button projected into custom-buttons\n  &.custom-buttons ::ng-deep {\n    .mat-mdc-icon-button {\n      width: 18px;\n      height: 18px;\n      padding: 0;\n      line-height: 18px;\n\n      .mat-mdc-button-touch-target {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n}\n\n.dock-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.dock-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  display: flex;\n  gap: 2px;\n  padding: 4px;\n  background: var(--preset-card, #073642);\n  border: 1px solid rgba(128, 128, 128, 0.5);\n  border-radius: 4px;\n  z-index: 3000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n\n  button {\n    width: 24px;\n    height: 24px;\n    padding: 2px;\n    border: 1px solid transparent;\n    border-radius: 3px;\n    background: transparent;\n    cursor: pointer;\n    opacity: 0.8;\n\n    &:hover {\n      opacity: 1;\n      background: rgba(128, 128, 128, 0.2);\n      border-color: rgba(128, 128, 128, 0.4);\n    }\n  }\n}\n\nbutton mat-icon, .buttons ::ng-deep mat-icon {\n  font-size: 14px;\n  line-height: 14px;\n  height: 14px;\n  width: 14px;\n  color: currentColor;\n}\n\n// Ensure custom buttons have visible color (fallback for dark mode)\n.buttons.custom-buttons {\n  button {\n    color: var(--preset-foreground, #93a1a1);\n\n    mat-icon {\n      color: var(--preset-foreground, #93a1a1);\n    }\n  }\n}\n\n.title {\n  font-weight: bold;\n  margin-left: 5px;\n  margin-top: 5px;\n\n  .dirty-indicator {\n    color: var(--preset-primary, #2aa198);\n    margin-left: 2px;\n  }\n}\n\n.subtitle {\n  font-size: 11px;\n  opacity: 0.5;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
